import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import logo from '../assets/images/logo.png'
import googleimage from '../assets/images/googleimage.png'

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaStore,
  FaHotel,
  FaUtensils,
  FaGlassCheers,
  FaCalendarAlt,
  FaDumbbell,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal
} from 'react-icons/fa';
import paarbusiness from '../assets/images/paarbusiness.png'
import paardigital from '../assets/images/paardigital.png'
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { webDetails, serviceCategory } from '../api/api';
import { Link } from 'react-router';
function PrivacyPolicy() {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [webData, setWebData] = useState(null);
  const [servCat, serviCateg] = useState(null);

  useEffect(() => {
    webDetails()
      .then((res) => {
        setWebData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    serviceCategory()
      .then((res) => {
        serviCateg(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // const categories = [
  //   { name: "Shops", icon: <FaStore />, url: "/category/shops" },
  //   { name: "Hotels", icon: <FaHotel />, url: "/category/hotels" },
  //   { name: "Restaurants", icon: <FaUtensils />, url: "/category/restaurants" },
  //   { name: "Bars", icon: <FaGlassCheers />, url: "/category/bars" },
  //   { name: "Events", icon: <FaCalendarAlt />, url: "/category/events" },
  //   { name: "Fitness", icon: <FaDumbbell />, url: "/category/fitness" }
  // ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: webData?.faceBook, color: "#1877f2" },
    { icon: <FaTwitter />, url: webData?.twitter, color: "#1da1f2" },
    { icon: <FaInstagram />, url: webData?.instagram, color: "#e4405f" },
    { icon: <FaTiktok />, url: webData?.youtube, color: "#000000" },
    // { icon: <FaWhatsapp />, url: webData?.print, color: "#25d366" }
    {
      icon: <FaWhatsapp />,
      url: webData?.phone ? `https://wa.me/91${webData.phone}` : null,
      color: "#25d366"
    }
  ];

  const paymentIcons = [
    { icon: <FaCcVisa />, name: "Visa" },
    { icon: <FaCcMastercard />, name: "Mastercard" },
    { icon: <FaCcAmex />, name: "American Express" },
    { icon: <FaCcPaypal />, name: "PayPal" }
  ];

  const year = new Date().getFullYear();
  return (
    <>
      <header className={`simple-header ${sticky ? "simple-header--sticky" : ""}`}>
        <div className="container">
          <div className="simple-header__container">
            {/* Logo */}
            <div className="simple-header__logo">
              <NavLink to={'/'} title="Sparker - Directory and listings template">
                <img
                  src={logo}
                  alt="Logo"
                  className="simple-header__logo-img"
                />
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <nav className="simple-header__nav w-100">
              <ul className="simple-header__nav-list d-flex justify-content-end w-100 list-unstyled m-0">

                <li className="simple-header__nav-item me-3">
                  <NavLink to="/contact" className="simple-header__nav-link">
                    Contact Us
                  </NavLink>
                </li>

                {/* <li className="simple-header__nav-item me-3">
      <NavLink to="/terms" className="simple-header__nav-link">
        Terms and conditions
      </NavLink>
    </li> */}

                <li className="simple-header__nav-item">
                  <NavLink to="/privacy" className="simple-header__nav-link">
                    Privacy Policy
                  </NavLink>
                </li>

              </ul>
            </nav>

            {/* Google Play Store Button */}
            {/* <div className="simple-header__actions">
                        <a
                            href="https://play.google.com/store/apps"
                            className="simple-header__playstore-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={googleimage} alt="googleimage" />
                        </a>
                    </div> */}
            {/* <div className="d-flex gap-2 headerqr">
              <div className="qrimageall">
                <img src={paarbusiness} alt="paarbusiness" />
              </div>
              <div className="qrimageall">
                <img src={paardigital} alt="paardigital" />
              </div>
            </div> */}

            {/* Mobile Menu Button */}
            <button
              className="simple-header__mobile-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`simple-header__hamburger ${menuOpen ? "simple-header__hamburger--active" : ""}`}>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
              </span>
            </button>

            {/* Mobile Navigation Overlay */}
            <div
              className={`simple-header__mobile-overlay ${menuOpen ? "simple-header__mobile-overlay--active" : ""}`}
              onClick={() => setMenuOpen(false)}
            ></div>

            {/* Mobile Navigation Menu */}
            <nav className={`simple-header__mobile-nav ${menuOpen ? "simple-header__mobile-nav--active" : ""}`}>
              <div className="d-flex justify-content-between p-2">
                <div className="simple-header__mobile-header">
                  <img src={logo} alt="Logo" />
                </div>
                <button
                  className="simple-header__mobile-close"
                  onClick={() => setMenuOpen(false)}
                >
                  ✕
                </button>
              </div>
              <ul className="simple-header__mobile-nav-list">
                <li className="simple-header__mobile-nav-item">
                  <a href="/contact" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Contact Us</a>
                </li>
                {/* <li className="simple-header__mobile-nav-item">
                  <a href="/terms" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Terms and conditions</a>
                </li> */}
                <li className="simple-header__mobile-nav-item">
                  <a href="/privacy" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Privacy Policy</a>
                </li>
                <li className="simple-header__mobile-nav-item">
                  <a
                    href="https://play.google.com/store/apps"
                    className="simple-header__mobile-playstore-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setMenuOpen(false)}
                  >
                    <img src={googleimage} alt="googleimage" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>


      <div className="container">
        <div className="privacy-policy">
          <h1>Welcome to Paar’s Privacy Policy ("Privacy Policy" or "Policy")</h1>

          <p>Paar Digital Service Limited and its affiliates (collectively, "Paar Digital Service Limited", "we" or "us") are engaged in the business of providing web-based solutions to facilitate connections between customers that seek specific services and service professionals that offer these services. This Policy outlines our practices in relation to the collection, storage, usage, processing, and disclosure of personal data that you have consented to share with us when you access, use, or otherwise interact with our website available at https://paardigitalservice.com/ or mobile application 'Paar' (collectively, "Platform") or avail products or services that Paar offers you on or through the Platform (collectively, the "Services"). In this Policy, the services offered to you by service professionals on or through the Platform are referred to as "Professional Services".</p>

          <p>At Paar, we are committed to protecting your personal data and respecting your privacy. In order to provide you with access to the Services or the Professional Services, we have to collect and otherwise process certain data about you. This Policy explains how we process and use personal data about you.</p>

          <p>Please note that unless specifically defined in this Policy, capitalized terms shall have the same meaning described to them in our Terms and Conditions, available at https://paardigitalservice.com/ ("Terms"). Please read this Policy in consonance with the Terms.</p>

          <p>By using the Services, you confirm that you have read and agree to be bound by this Policy and consent to the processing activities described under this Policy.</p>

          <h1>1. BACKGROUND AND KEY INFORMATION</h1>
          <h5>(a) How this Policy applies:</h5>
          <p>This Policy applies to individuals who access or use the Services or otherwise avail the Professional Services. For the avoidance of doubt, references to "you" across this Policy are to an end user that uses the Platform. By using the Platform, you consent to the collection, storage, usage, and disclosure of your personal data, as described in and collected by us in accordance with this Policy.</p>

          <h5>(b) Review and Updates:</h5>
          <p>We regularly review and update our Privacy Policy, and we request you to regularly review this Policy. It is important that the personal data we hold about you is accurate and current. Please let us know if your personal data changes during your relationship with us.</p>

          <h5>(c) Third-Party Services:</h5>
          <p>The Platform may include links to third-party websites, plug-ins, services, and applications ("Third-Party Services"). Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We neither control nor endorse these Third-Party Services and are not responsible for their privacy statements. When you leave the Platform or access third-party links through the Platform, we encourage you to read the privacy policy of such third-party service providers.</p>

          <h1>2. PERSONAL DATA THAT WE COLLECT</h1>

          <ul>
            <li><strong>(i) Contact Data:</strong> such as your mobile number, email address, and location details (when provided by the user or required for app functionality).</li>
            <li><strong>(ii) Identity and Profile Data:</strong> such as your name, username or similar identifiers, photographs (if uploaded), and gender (if provided).</li>
            <li><strong>(iii) Authentication Data:</strong> such as mobile number verification details, OTP verification logs, and login-related information used to securely access the Platform.</li>
            <li><strong>(iv) Marketing and Communications Data:</strong> information shared through the Platform such as service requests, feedback, comments, and in-app messages exchanged with service providers. We do not record call audio.</li>
            <li><strong>(v) Technical Data:</strong> which includes IP address, device information, browser type, operating system, device ID, app usage activity, access time, clicks, and location data (only when location permission is enabled).</li>
            <li><strong>(vi) Transaction Data:</strong> such as details of services or membership purchased, payment status, and limited payment-related information provided by payment processors. We do not store full payment card details. UPI IDs may be collected for payment processing.</li>
            <li><strong>(vii) Usage Data:</strong> which includes information about how you use the Platform, such as app activity, page views, navigation patterns, and user interactions.</li>
          </ul>

          <p>We also collect aggregated and statistical data that does not directly identify you. If such data is combined with personal data in a way that identifies an individual, it will be treated as personal data under this Policy.</p>

          <h5>(c) What happens if I refuse to provide my personal data?</h5>
          <p>Where we need to collect personal data by law, or under the terms of a contract (such as the Terms), and you fail to provide that data when requested, we may not be able to perform the contract (for example, to provide you with the Services). In this case, we may have to cancel or limit your access to the Services.</p>

          <h1>3. HOW DO WE COLLECT PERSONAL DATA?</h1>

          <p>We use different methods to collect personal data from and about you including through:</p>

          <h5>(a) Direct Interactions:</h5>
          <p>You provide us your personal data when you interact with us. This includes personal data you provide when you:</p>
          <ul>
            <li>Create an account or profile with us;</li>
            <li>Use our Services or carry out other activities in connection with the Services;</li>
            <li>Enter a promotion, user poll, or online surveys;</li>
            <li>Request marketing communications to be sent to you;</li>
            <li>Report a problem with the Platform and/or our Services, give us feedback, or contact us.</li>
          </ul>

          <h5>(b) Automated Technologies or Interactions:</h5>
          <p>Each time you visit the Platform or use the Services, we will automatically collect Technical Data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, web beacons, pixel tags, server logs, and other similar technologies. We may also receive Technical Data about you if you visit other websites or apps that employ our cookies.</p>

          <h5>(c) Third Parties or Publicly Available Sources:</h5>
          <p>We will receive personal data about you from various third parties:</p>
          <ul>
            <li>Technical data from analytics providers such as Facebook and advertising networks;</li>
            <li>Identity and profile-related Data and Contact Data from service professionals, publicly available sources, etc.;</li>
            <li>Personal data about you from our affiliate entities.</li>
          </ul>

          <h1>4. HOW DO WE USE YOUR PERSONAL DATA?</h1>

          <p>(a) We will only use your personal data when the law allows us to. Most commonly, we will use your personal data where we need to provide you with the Services, enable you to use the Professional Services, or where we need to comply with a legal obligation. We use your personal data for the following purposes:</p>
          <ul>
            <li>To verify your identity to register you as a user, and create your user account with us on the Platform;</li>
            <li>To provide the Services to you;</li>
            <li>To enable the provision of Professional Services to you;</li>
            <li>To monitor trends and personalize your experience;</li>
            <li>To improve the functionality of our Services based on the information and feedback we receive from you;</li>
            <li>To improve customer service to effectively respond to your Service requests and support needs;</li>
            <li>To track transactions and process payments;</li>
            <li>To send periodic notifications to manage our relationship with you;</li>
            <li>To assist with the facilitation of the Professional Services offered to you;</li>
            <li>To market and advertise the Services to you;</li>
            <li>To comply with legal obligations;</li>
            <li>To administer and protect our business and the Services;</li>
            <li>To improve our business and delivery models;</li>
            <li>To perform our obligations that arise out of the arrangement we are about to enter or have entered with you;</li>
            <li>To enforce our Terms;</li>
            <li>To respond to court orders or legal claims.</li>
          </ul>

          <p>(b) You agree and acknowledge that by using our Services and creating an account with us on the Platform, you authorize us, our service professionals, associate partners, and affiliates to contact you via email, phone, or otherwise. This is to provide the Services to you and ensure that you are aware of all the features of the Services and for related purposes.</p>

          <p>(c) You agree and acknowledge that any and all information pertaining to you, whether or not you directly provide it to us, including personal correspondence such as emails, instructions, etc., may be collected, compiled, and shared by us in order to render the Services to you. This may include service professionals, vendors, third-party service providers, storage providers, data analytics providers, consultants, and affiliates.</p>





          <p>(d) You agree and acknowledge that we may share data without your consent when required by law or by court order to disclose such information. Such disclosures are made in good faith and belief that it is reasonably necessary to do so for enforcing this Policy or the Terms or to comply with applicable laws.</p>

          <h1>5. COOKIES</h1>

          <h5>(a) What are Cookies?</h5>
          <p>
            Cookies are small files that a site or its service provider transfers to your device's hard drive through your web browser (if you permit it to) that enables the sites or service providers' systems to recognise your browser and capture and remember certain information.
          </p>

          <h5>(b) How We Use Cookies</h5>
          <p>
            We use cookies to help us distinguish you from other users of the Platform, understand and save your preferences for future visits, keep track of advertisements, and compile aggregate data about site traffic and site interaction so that we can offer you a seamless user experience. We may contact third-party service providers to assist us in better understanding our site visitors. These service providers are not permitted to use the information collected on our behalf except to help us conduct and improve our business.
          </p>

          <h5>(c) Third-Party Cookies</h5>
          <p>
            Additionally, you may encounter cookies or other similar devices on certain pages of the Platform that are placed by third parties. We do not control the use of cookies by third parties. If you send us personal correspondence, such as emails, or if other users or third parties send us correspondence about your activities or postings on the Platform, we may collect such information within a file specific to you.
          </p>


          <h1>6. DISCLOSURES OF YOUR PERSONAL DATA</h1>

          <h5>(a) Who We Share Your Personal Data With</h5>
          <p>
            We may share your personal data with third parties set out below for the purposes set out in Section 4:
          </p>
          <ul>
            <li>Service professionals to enable them to provide you with Professional Services;</li>
            <li>Internal third parties, which are other companies within the Paar Digital Service group of companies.</li>
            <li>External third parties such as:
              <ul>
                <li>Trusted third parties such as our associate partners, and service providers that provide services for us or on our behalf. This includes hosting and operating our Platform, providing marketing assistance, conducting our business, processing payments and transaction-related processes, transmitting content, and providing our Services to you;</li>
                <li>Analytic service providers and advertising networks that conduct web analytics for us to help us improve the Platform. These analytics providers may use cookies and other technologies to perform their services;</li>
                <li>Other registered users on our Platform upon your request or where you explicitly consent to such disclosure;</li>
                <li>Regulators and other bodies, as required by law or regulation.</li>
              </ul>
            </li>
          </ul>

          <h5>(b) Third-Party Data Processing</h5>
          <p>
            We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.
          </p>

          <h1>7. YOUR RIGHTS IN RELATION TO YOUR PERSONAL DATA</h1>

          <h5>(a) Access and Updating Your Personal Data</h5>
          <p>
            You hereby warrant that all personal data that you provide us with is accurate, up-to-date, and true. When you use our Services, we make best efforts to provide you with the ability to access and correct inaccurate or deficient data, subject to any legal requirements. You can request Paar Digital Service for a copy of your personal data by sending an email to sales@paardigitalservice.com. Paar Digital Service may take up to 15 (fifteen) working days to respond to such request.
          </p>

          <h5>(b) Opting-Out of Marketing and Promotional Communications</h5>
          <p>
            When we send you marketing and promotional content through email, we make best efforts to provide you with the ability to opt-out of such communications by using the opt-out instructions provided in such emails. You understand and acknowledge that it may take us up to 15 (fifteen) business days to give effect to your opt-out request. Please note that we may still send you emails about your user account or any Services you have requested or received from us.
          </p>


          <h1>8. DELETION OF ACCOUNT AND PERSONAL DATA</h1>

          <h3>(a) How to Delete Your Account</h3>
          <p>
            Users may delete their account and associated personal data using the in-app “Delete Account” feature after mobile number verification via OTP, or by sending a request to sales@paardigitalservice.com.
            For in-app deletion, users must verify their identity through OTP authentication to ensure account security.
            Paar Digital Service will process deletion requests within 15 (fifteen) working days of verification.
            Once the account is deleted, users will lose access to all Services.
            For clarity, certain transactional data related to services or payments may be retained for legal, regulatory, or compliance purposes as required under applicable law.
          </p>

          <h1>9. TRANSFERS OF YOUR PERSONAL DATA</h1>

          <h5>(a) International Transfers</h5>
          <p>
            We comply with applicable laws in respect of storage and transfers of personal data. As a part of your use of the Services, the information and personal data you provide to us may be transferred to and stored in countries other than the country you are based in. This may happen if any of our servers are from time to time located in a country other than the one you are based, or one of our vendors, partners, or service providers is located in a country other than one you are based in.
          </p>

          <h5>(b) Consent to Transfers</h5>
          <p>
            By submitting your information and personal data to us, you agree to the transfer, storage, and processing of such information and personal data in the manner described above.
          </p>

          <h1>10. DATA SECURITY</h1>

          <h5>(a) Security Measures</h5>
          <p>
            We implement appropriate security measures and privacy-protective features on our Platform including encryption, password protection, call masking, and physical security measures to protect your personal data from unauthorised access and disclosure, and follow standards prescribed by applicable law.
          </p>

          <h5>(b) Responsibility for Passwords</h5>
          <p>
            Where you have chosen a password that enables you to access certain parts of the Services or Professional Services, you are responsible for keeping this password secret and confidential. We will not be responsible for any unauthorised use of your information, or for any lost, stolen, or compromised passwords, or for any activity on your user account due to such unauthorised disclosure of your password. In the event your password has been compromised in any manner whatsoever, you should promptly notify us to enable us to initiate a change of password.
          </p>

          <h1>11. DATA RETENTION</h1>

          <h5>(a) Retention Period</h5>
          <p>
            You agree and acknowledge that your personal data will continue to be stored and retained by us for as long as necessary to fulfil our stated purpose(s) and for a reasonable period after the termination of your account on the Platform or access to the Services to comply with our legal rights and obligations.
          </p>

          <h5>(b) Aggregated Data</h5>
          <p>
            In some circumstances, we may aggregate your personal data (so that it can no longer be associated with you) for research or statistical purposes, in which case we may use this information indefinitely without further notice to you.
          </p>

          <h1>12. BUSINESS TRANSITIONS</h1>

          <p>
            You are aware that in the event we go through a business transition, such as a merger, acquisition by another organisation, or sale of all or a portion of our assets, your personal data might be among the assets transferred.
          </p>

          <h1>13. USER GENERATED CONTENT</h1>

          <p>
            We invite you to post content on our Platform, including your comments, feedback, pictures, or any other information that you would like to be made available on our Platform. Please note that such content will be available to all visitors to our Platform and may become public. We cannot prevent such information from being used in a manner that is contrary to this Policy, applicable laws, or your personal privacy, and we disclaim all liability (express or implied) in this regard. Further, you agree to comply with all applicable laws in relation to the content uploaded or otherwise shared by you on our Platform. You understand and acknowledge that you will be solely responsible for any information published by you on our Platform that violates applicable laws.
          </p>

          <h1>14. UPDATES TO THIS POLICY</h1>

          <h5>(a) Notification of Changes</h5>
          <p>
            We may occasionally update this Policy. If we make changes to this Policy, we will upload the revised policy on the Platform or share it with you through other means, such as email. To the extent permitted under applicable law, by using our Platform after such notice, you consent to updates made to this Policy.
          </p>

          <h5>(b) Encouragement to Review</h5>
          <p>
            We encourage you to periodically review this Policy for the latest information on our privacy practices.
          </p>

          <h1>15. CLAUSE</h1>

          <p>
            By submitting our webform, you agree to receive calls on the number shared, and such calls and SMS would be coming from a third-party platform.
          </p>

          <h1>16. GRIEVANCE OFFICER</h1>

          <p>
            If you have any questions about this Policy, how we process or handle your personal data, or otherwise, you may reach out to us, with your queries, grievances, feedback, and comments at sales@paardigitalservice.com or contact our grievance officer whose contact details are provided below:
          </p>

          <p>
            <strong>Grievance Officer</strong><br />
            Name: Mr. Aman Tak<br />
            Designation: Director<br />
            Email: sales@paardigitalservice.com
          </p>

        </div>

      </div>
      <footer className="app-footer">

        <div className="container footer-container">
          <div className="row g-4">

            {/* About */}
            <div className="col-lg-6 col-md-6 col-sm-6">
              <h3 className="footer-title">About Us</h3>

              <p>
                {webData?.aboutUsLong || "Loading..."}
              </p>

              <div className="social-section">
                <h5>Follow Us</h5>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    social.url && (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ '--social-color': social.color }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = social.color;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                        }}
                      >
                        {social.icon}
                      </a>
                    )
                  ))}
                </div>
              </div>
            </div>

            {/* Categories */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Categories</h3>
              <ul className="footer-links">
                {servCat && servCat.map((cat) => (
                  <li key={cat._id}>
                    <a href="#">
                      {cat.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Contacts</h3>

              <div className="contact-item">
                <MdLocationOn />
                <span>{webData?.address || "Loading..."}</span>
              </div>

              <div className="contact-item">
                <MdPhone />
                {webData?.phone && (
                  <a href={`tel:+91${webData.phone}`}>
                    +91 {webData.phone}
                  </a>
                )}
              </div>

              <div className="contact-item">
                <MdEmail />
                {webData?.email && (
                  <a href={`mailto:${webData.email}`}>
                    {webData.email}
                  </a>
                )}
              </div>
              {/* <div className="d-flex footer_qr">
                <div className="qrimageall">
                  <img src={paarbusiness} alt="paarbusiness" />
                </div>
                <div className="qrimageall">
                  <img src={paardigital} alt="paardigital" />
                </div>
              </div> */}
            </div>

          </div>

          <hr className="footer-divider" />

          <div className="row align-items-center footer-bottom">
            <div className="col-lg-6">
              <div className="selector-group">
                {/* Payment Icons */}
                <div className="payment-icons">
                  {paymentIcons.map((payment, index) => (
                    <span key={index} title={payment.name}>
                      {payment.icon}
                    </span>
                  ))}
                </div>
              </div>
            </div>


            <div className="col-lg-6">
              <ul className="footer-links-bottom">
                <li><Link to={"/contact"}>Contact Us</Link></li>
                {/* <li><Link to={"/terms"}>Terms and conditions</Link></li> */}
                <li><Link to={"/privacy"}>Privacy Policy</Link></li>
                <li>
                  <span className='text-white'>
                    © {year}. All rights reserved
                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}

export default PrivacyPolicy;
